import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrowup2",
  "use": "rt-base-arrowup2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-arrowup2\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.9 449l211.7 211.7c15.6 15.6 41 15.6 56.6 0 15.6-15.6 15.6-41 0-56.6l-240-240c-3.9-3.9-8.4-6.8-13.2-8.8-8.4-3.4-17.8-3.8-26.5-1.3-1.3 0.4-2.4 0.8-3.7 1.3-4.8 1.9-9.3 4.9-13.2 8.8l-240 240c-15.6 15.6-15.6 41 0 56.6s41 15.6 56.6 0L511.9 449z\" p-id=\"2554\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrowup2.svg
// module id = 1644
// module chunks = 228